export const SOCIALS_LINKS = [
  {
    id: 'tg',
    url: 'https://t.me/+wxcx1CVeqZI3NTYy',
  },
  {
    id: 'vk-video',
    url: 'https://vkvideo.ru/playlist/-210379388_29',
  },
];

export const SOB_SOCIALS_LINKS = [
  {
    id: 'tg-colored',
    url: 'https://t.me/cian_official',
  },
  {
    id: 'vk-colored',
    url: 'https://vk.com/cian_official',
  },
  {
    id: 'yt-colored',
    url: 'https://www.youtube.com/@cian_official',
  },
];
